import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PackageInformationService {
  constructor() {
  }

  private chargeCodes = new BehaviorSubject<any[]>(null);
  private selectedChargeCodes = new BehaviorSubject<any[]>(null);
  private deletedChargeCodes = new BehaviorSubject<any[]>(null);
  chargeCodeList = this.chargeCodes.asObservable().pipe(distinctUntilChanged());
  selectedChargeCodeList = this.selectedChargeCodes.asObservable().pipe(distinctUntilChanged());
  deletedChargeCodeList = this.deletedChargeCodes.asObservable().pipe(distinctUntilChanged());

  setChargeCodes(chargeCodeList: []) {
    this.chargeCodes.next(chargeCodeList);
  }

  getChargeCodes() {
    return this.chargeCodeList;
  }

  setselectedChargeCodes(selectedChargeCodeList: []) {
    this.selectedChargeCodes.next(selectedChargeCodeList);
  }

  getSelectedChargeCodes() {
    return this.selectedChargeCodeList;
  }

  setDeletedChargeCodes(deletedChargeCodeList: []) {
    this.deletedChargeCodes.next(deletedChargeCodeList);
  }

  getDeletedChargeCodes() {
    return this.deletedChargeCodeList;
  }

  destroySubjects() {
    this.chargeCodes.unsubscribe();
    this.selectedChargeCodes.unsubscribe();
    this.deletedChargeCodes.unsubscribe();
  }
}
